import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import useScreen from 'hooks/useScreen';
import ShopPagePromotionPanel from './components/ShopPagePromotionPanel';
import TwoColumns from './components/TwoColumns';

import {
  DiningRoomPanel,
  DecorPanel,
  BedroomPanel,
  OutdoorPanel,
  LivingRoomPanelMobile,
  LivingRoomPanelTablet,
  LivingRoomPanelDesktop,
} from './components/shopPagePanels';

const ShopPageColumns = ({ config = {} }) => {
  const { isMobile, isMobileOrTablet } = useScreen();

  if (isMobile) {
    return (
      <FixedWidthContainer noMobilePadding>
        <div className="md:[column-count:2] md:[column-gap:1.5rem] md:pb-6 lg:[column-count:3] [&_>_*]:mb-0 [&_>_*]:md:rounded-[.5rem] [&_>_*]:md:break-inside-avoid [&_>_*]:md:mb-6 [&_a]:no-underline [&_a:hover]:!text-gray">
          <ShopPagePromotionPanel config={config} />
          <LivingRoomPanelMobile />
          <DiningRoomPanel />
          <DecorPanel />
          <BedroomPanel />
          <OutdoorPanel />
        </div>
      </FixedWidthContainer>
    );
  }

  if (isMobileOrTablet) {
    return (
      <>
        <ShopPagePromotionPanel config={config} />

        <FixedWidthContainer>
          <div className="grid grid-rows-[auto] rounded-[.5rem] mb-0 grid-cols-[1fr_1fr] gap-6 [grid-template-areas:'ShopPagePromotionPanel_ShopPagePromotionPanel''ShopPageCategoryPanelLivingRoom_ShopPageCategoryPanelLivingRoom''ShopPageTabletLeftPanel_ShopPageTabletRightPanel']">
            <LivingRoomPanelTablet />

            <div className="[&>*]:rounded-[.5rem] [&>*]:mb-6 [&>*:last-child]:mb-0 [grid-area:ShopPageTabletLeftPanel]">
              <DiningRoomPanel />
              <DecorPanel />
            </div>

            <div className="[&>*]:rounded-[.5rem] [&>*]:mb-6 [&>*:last-child]:mb-0 [grid-area:ShopPageTabletRightPanel]">
              <BedroomPanel />
              <OutdoorPanel />
            </div>
          </div>
        </FixedWidthContainer>
      </>
    );
  }

  return (
    <FixedWidthContainer>
      <div
        className={classNames(
          "grid grid-rows-[auto] grid-cols-[1fr_2fr] [column-gap:2rem] [row-gap:1.5rem] mt-0 [grid-template-areas:'ShopPageDesktopLeftColumn_ShopPageDesktopMainColumn']",
          '[&>*]:rounded-[.5rem] [&>*]:mb-0',
          '[&_a]:no-underline',
          '[&_a]:hover:!text-gray'
        )}
      >
        <div
          className={classNames(
            '[grid-area:ShopPageDesktopLeftColumn]',
            '[&>*]:rounded-[.5rem] [&>*]:mt-6',
            '[&>*:first-child]:mt-0'
          )}
        >
          <ShopPagePromotionPanel config={config} />
          <DiningRoomPanel />
          <DecorPanel />
        </div>

        <div className="[grid-area:ShopPageDesktopMainColumn]">
          <LivingRoomPanelDesktop />

          <TwoColumns
            column1={
              <div>
                <BedroomPanel />
              </div>
            }
            column2={
              <div>
                <OutdoorPanel />
              </div>
            }
          />
        </div>
      </div>
    </FixedWidthContainer>
  );
};

ShopPageColumns.propTypes = {
  config: PropTypes.object,
};

export default ShopPageColumns;
